import { propertyTypeReducer } from '@domain-group/fe-allhomes-library';
import { PropertyType } from '../types';
export var reducePropertyType = propertyTypeReducer([PropertyType.HOUSE, PropertyType.TOWNHOUSE, PropertyType.UNIT]);
export var simplifyFeatures = features => ({
  bedrooms: features.bedrooms,
  bathrooms: features.bathrooms.total,
  parking: features.parking.total,
  propertyType: reducePropertyType(features.propertyType),
  eer: features.eer
});